import { render, staticRenderFns } from "./TNewButton.vue?vue&type=template&id=a553277c&scoped=true&"
import script from "./TNewButton.vue?vue&type=script&lang=ts&"
export * from "./TNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./TNewButton.vue?vue&type=style&index=0&id=a553277c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a553277c",
  null
  
)

export default component.exports